import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const rolGuardMonitorist: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userData = authService.getUser()
  if (!userData.token){
    router.navigate(["auth/login"]);
    return false
  }
   if(  userData.rol === 'monitorista') {
    return true;
  } else{
    if(userData.rol === 'admin'){router.navigate(["admin/home/dashboard"]);}
    if(userData.rol === 'cliente'){router.navigate(["client/home/dashboard"]);}
    return false
  }
};
